<script>
  import { ICONS } from "./../../../js/icons.js";
  import { onMount } from "svelte";
  import Configuration from "../../../config.js";

  export let onCategoryChange;
  export let active_view;

  export let homeStrategy;
  export let patePlyaStrategy;
  export let pragmaticStrategy;
  export let novusCasinoStrategy;
  export let barbaraBangStrategy;
  export let endorphinaStrategy;
  export let igpStrategy;
  export let amigoGamingStrategy;
  export let anakatechStrategy;
  export let altenarStrategy;
  export let firstStrategyV2;
  export let clientsStrategy;

  const MENU = [
    { id: "home", label: "HOME", iconHtmlKey: "database" },
    { id: "pate", label: "FREESPIN PATEPLAY", iconHtmlKey: "database" },
    { id: "pragmatic", label: "FREESPIN PRAGMATIC", iconHtmlKey: "database" },
    { id: "novus", label: "FREESPIN NOVUS", iconHtmlKey: "database" },
    { id: "barbara", label: "BAR-BARA-BANG", iconHtmlKey: "database" },
    { id: "endorphina", label: "FB-ENDORPHINA", iconHtmlKey: "database" },
    { id: "igp", label: "FREESPIN IGP", iconHtmlKey: "database" },
    { id: "amigo", label: "FREESPIN AMIGO", iconHtmlKey: "database" },
    { id: "anakatech", label: "FREESPIN ANAKATECH", iconHtmlKey: "database" },
    { id: "altenar", label: "ALTENAR SPORTSBOOK", iconHtmlKey: "database"},
    { id: "firstV2", label: "FIRST V2", iconHtmlKey: "database" },
    { id: "clients", label: "BANNERS", iconHtmlKey: "image" },
  ];

  let role = null;
  let allowed = [];
  let ready = false;

  $: strategyMap = {
    home: homeStrategy,
    pate: patePlyaStrategy,
    pragmatic: pragmaticStrategy,
    novus: novusCasinoStrategy,
    barbara: barbaraBangStrategy,
    endorphina: endorphinaStrategy,
    igp: igpStrategy,
    amigo: amigoGamingStrategy,
    anakatech: anakatechStrategy,
    altenar: altenarStrategy,
    firstV2: firstStrategyV2,
    clients: clientsStrategy,
  };

  const canSee = (id) => allowed.includes(id);
  const isDisabled = (id) => false;

  function isActive(id) {
    const strategyValue = strategyMap[id];
    return active_view === strategyValue || active_view === id;
  }

  function getHeaders() {
    try {
      const userDataRaw = sessionStorage.getItem("user");
      const token = sessionStorage.getItem("token");
      if (!userDataRaw || !token) return {};
      const parsedUser = JSON.parse(userDataRaw);
      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-tenant": parsedUser?.destine || "",
      };
    } catch {
      return {};
    }
  }

  async function fetchGroupViews(groupCode) {
    try {
      const conf = Configuration.getConfiguration();
      const response = await fetch(
        `${conf.ADMI_BO}/credentials?prefix=client_group.${groupCode}.views`,
        { headers: getHeaders() }
      );
      const map = await response.json();
      const viewsKey = `client_group.${groupCode}.views`;
      const raw = map[viewsKey];
      if (raw) {
        return raw.split(",").map((v) => v.trim()).filter(Boolean);
      }
    } catch (e) {
      console.error("Error fetching views for group", groupCode, e);
    }
    return null;
  }

  onMount(async () => {
    let data = {};
    try {
      data = JSON.parse(sessionStorage.getItem("user") || "{}");
    } catch {}
    const rawRole = data && data.rol;
    role = Number.isFinite(Number(rawRole)) ? Number(rawRole) : null;

    // SUPER_ADMIN: all views
    if (role === -1) {
      allowed = MENU.map((item) => item.id);
      ready = true;
      return;
    }

    // ADMIN: check am_views per user
    if (role === 10) {
      const userId = data?.id;
      if (userId) {
        try {
          const conf = Configuration.getConfiguration();
          const res = await fetch(
            `${conf.ADMI_BO}/credentials?prefix=am_views.${userId}`,
            { headers: getHeaders() }
          );
          const map = await res.json();
          const raw = map[`am_views.${userId}`];
          if (raw && raw.trim()) {
            const views = raw.split(",").map((v) => v.trim()).filter(Boolean);
            if (views.length > 0) {
              allowed = views;
              ready = true;
              return;
            }
          }
        } catch (e) {
          console.error("Error fetching am_views", e);
        }
      }
      allowed = [];
      ready = true;
      return;
    }

    // Non-role-10: fallback to group-based views
    const groupCode = data?.client_code ?? data?.clientCode ?? null;
    if (groupCode) {
      const views = await fetchGroupViews(groupCode);
      if (views && views.length > 0) {
        allowed = views;
      }
    }
    ready = true;
  });

  function handleClick(id) {
    if (isDisabled(id)) return;
    const strategy = strategyMap[id];
    const newView = strategy ?? id;
    onCategoryChange(newView);
    active_view = newView;
  }
</script>

{#if ready}
  <div class="btn-menu-central">
    {#each MENU as item}
      {#if canSee(item.id)}
        <button
          class="btn-op"
          class:u-category-select={active_view ===
            (strategyMap[item.id] ?? item.id)}
          class:is-disabled={isDisabled(item.id)}
          disabled={isDisabled(item.id)}
          on:click={() => handleClick(item.id)}
        >
          {#if item.iconHtmlKey}
            {@html ICONS[item.iconHtmlKey]}
          {/if}
          <span>{item.label}</span>
        </button>
      {/if}
    {/each}
  </div>
{:else}
  <div style="min-height:48px"></div>
{/if}

<style>
  .btn-menu-central {
    display: flex;
    justify-content: center;
    gap: 0.8rem;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0.5rem;
  }

  .btn-op {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.3rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-decoration: none;
    width: 12rem;
    text-align: center;
    color: #fff;
    border-radius: 0.4rem;
    background-color: #ff0090;
    border: none;
  }

  .btn-op:hover {
    background-color: #e100ff;
  }
  .u-category-select {
    background-color: #e100ff;
    border: none;
    color: #fff;
    border-radius: 0.4rem;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  @media (max-width: 600px) {
    .btn-menu-central {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
  }
</style>
